import React, { Component } from "react";
import { connect } from "react-redux";
import "./personalInfo.scss";
import NumberFormat from "react-number-format";
import util from "../../_helpers/util";
import { confirmAlert } from "react-confirm-alert";

const step = 1;
const page = "personalInfo";
class PersonalInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chkSameAddress: false,
      maddress1: false,
      maddress2: false,
      mcity: false,
      mstate: false,
      mzip: false,
      canApply: true,
      form: {
        position_applying_for: "",
        fname: "",
        sname: "",
        lname: "",
        physicalStreetAddress1: "",
        physicalStreetAddress2: "",
        physicalCity: "",
        physicalState: "",
        physicalZip: "",
        tmpMailingAddress1: "",
        tmpMailingAddress2: "",
        tmpMailingCity: "",
        tmpMailingState: "",
        tmpMailingZip: "",
        mailingAddress1: "",
        mailingAddress2: "",
        city: "",
        state: "",
        zip: "",
        email: "",
        main_phone: "",
        secondary_phone: "",
        sourceOfKnowledge: "",
        employee_name: "",
        step: step,
      },
    };
  }

  preventNegativeValueInDocs = (e) => {
    if (
      (e.key === "ArrowDown") ||
      (e.key === "ArrowUp") ||
      e.key === "-" ||
      e.key === "e"
    ) {
      e.preventDefault();
    }
  }

  blur(event) {
    util.blur(event);
  }
  submitForm(event) {
    event.preventDefault();
    if (!util.forceVlidate(document.getElementById(page))) {
      return;
    }
    if (!this.state.canApply) {
      confirmAlert({
        title: "Application Update Restricted",
        message: "You cannot update your job application as it may currently be under review or archived. Please email hr@firestormfire.com if you believe this is incorrect.",
        buttons: [
          {
            label: "Close",
            onClick: () => {},
          },
        ],
      });
      return;
    }
    if ("function" === typeof this.props.action) {
      //this.props.dispatch(apis.hasChanges(this.state.__changes))
      this.props.action({ ...this.state.form, step }, step);
      this.setState({
        __changes: false,
      });
    }
  }
  setValue(event) {
    if (event.target.classList.contains("aplcn-has-error")) {
      event.target.classList.remove("aplcn-has-error");
    }
    util.setValue.call(this, event);
    if (util.isblurred(event.target)) {
      var valid = util.validate(event.target);
    }
    var address = [
        "form.physicalStreetAddress1",
        "form.physicalStreetAddress2",
        "form.physicalCity",
        "form.physicalState",
        "form.physicalZip",
      ],
      ob = {};
    if (address.indexOf(event.target.name) > -1 && this.state.chkSameAddress) {
      ob = {
        mailingAddress1: this.state.form.physicalStreetAddress1,
        mailingAddress2: this.state.form.physicalStreetAddress2,
        city: this.state.form.physicalCity,
        state: this.state.form.physicalState,
        zip: this.state.form.physicalZip,
      };
    }
    this.setState(
      {
        form: {
          ...this.state.form,
          ...ob,
        },
      },
      () => {},
    );
  }
  componentDidMount() {
    if (this.props.api && this.props.api.aplicationDetail) {
      //
      this.setDefaultData();
    } else {
      this.setState({
        form: Object.assign({}, this.state.form, {
          email: localStorage.getItem("__userEmail"),
        }),
      });
    }
  }

  componentDidUpdate(prevProps) {
    const applicationDetails =
      this.props.api && this.props.api.aplicationDetail;
    const prevApplicationDetails =
      prevProps.api && prevProps.api.aplicationDetail;
    const shouldSetDefaultValues = !!(
      (applicationDetails && applicationDetails.hash) !==
      (prevApplicationDetails && prevApplicationDetails.hash)
    );

    if (shouldSetDefaultValues) {
      this.setDefaultData();
    }
  }

  setDefaultData() {
    if (this.props.api && this.props.api.aplicationDetail) {
      var data = this.props.api.aplicationDetail,
        obj = Object.assign({}, this.state.form);
      this.setState({
        canApply: data.can_apply,
        form: util._merge(obj, data, {
          position_applying_for: "position_applying_for",
          fname: "first_name",
          lname: "last_name",
          sname: "middle_initial",
          email: "email_address",
          zip: "zip_id",
          state: "state_id",
          city: "city_id",
          mailingAddress1: "mailing_address1",
          mailingAddress2: "mailing_address2",
          physicalStreetAddress1: "physical_street_address1",
          physicalStreetAddress2: "physical_street_address2",
          physicalCity: "physical_city_id",
          physicalState: "physical_state_id",
          physicalZip: "physical_zip_id",
          main_phone: "phone_number",
          sourceOfKnowledge: "source_of_knowledge_id",
          employee_name: "firestorm_employee",
        }),
      });
    }
  }

  handleAddress(e) {
    var value = e.target.value;

    if (e.target.checked) {
      this.setState({
        form: {
          ...this.state.form,
          tmpMailingAddress1: this.state.form.mailingAddress1,
          tmpMailingAddress2: this.state.form.mailingAddress2,
          tmpMailingCity: this.state.form.city,
          tmpMailingState: this.state.form.state,
          tmpMailingZip: this.state.form.zip,
          mailingAddress1: this.state.form.physicalStreetAddress1,
          mailingAddress2: this.state.form.physicalStreetAddress2,
          city: this.state.form.physicalCity,
          state: this.state.form.physicalState,
          zip: this.state.form.physicalZip,
        },
        chkSameAddress: true,
        maddress1: true,
        maddress2: true,
        mcity: true,
        mstate: true,
        mzip: true,
      });
      if (document.getElementById("mailingAddress1"))
        document
          .getElementById("mailingAddress1")
          .classList.remove("aplcn-has-error");

      if (document.getElementById("mailingAddress2"))
        document
          .getElementById("mailingAddress2")
          .classList.remove("aplcn-has-error");

      if (document.getElementById("city"))
        document.getElementById("city").classList.remove("aplcn-has-error");

      if (document.getElementById("state"))
        document.getElementById("state").classList.remove("aplcn-has-error");

      if (document.getElementById("zip"))
        document.getElementById("zip").classList.remove("aplcn-has-error");
    } else {
      this.setState({
        form: {
          ...this.state.form,
          mailingAddress1: this.state.form.tmpMailingAddress1,
          mailingAddress2: this.state.form.tmpMailingAddress2,
          city: this.state.form.tmpMailingCity,
          state: this.state.form.tmpMailingState,
          zip: this.state.form.tmpMailingZip,
        },
        maddress1: false,
        maddress2: false,
        mcity: false,
        mstate: false,
        mzip: false,
        chkSameAddress: false,
      });
    }
  }

  toggleAddressCheckbox = () => {
    const chkSameAddressCheckbox = document.getElementById("chkSameAddress");
    chkSameAddressCheckbox.checked = !chkSameAddressCheckbox.checked; // Toggle the checkbox
    this.handleAddress({ target: chkSameAddressCheckbox }); // Call handleAddress function with checkbox event
  };

  render() {
    var prefetchedData = this.props.api || {};
    return (
      <div className="aplcn-form aplcn-form-one">
        <form method="post" onSubmit={this.submitForm.bind(this)} id={page}>
          <div className="aplcn-form-section-head">
            <h4>How Did You Hear About Applying To Firestorm?*</h4>
          </div>
          <div className="aplcn-form-row-main aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <select
                  required
                  onBlur={this.blur.bind(this)}
                  onChange={this.setValue.bind(this)}
                  className=""
                  value={this.state.form.sourceOfKnowledge}
                  name="form.sourceOfKnowledge"
                  title="Source of Knowledge of Firestorm"
                >
                  <option value=""> --- Select Location --- </option>
                  {prefetchedData.SourceOfKnowledge &&
                    prefetchedData.SourceOfKnowledge.map((item, index) => {
                      return (
                        <option
                          value={item.id}
                          key={"sourceOfKnowledge_" + item.id}
                        >
                          {item.value}
                        </option>
                      );
                    })}
                </select>
              </div>
              {this.state.form.sourceOfKnowledge == "1" && (
                <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                  <input
                    type="text"
                    name="form.employee_name"
                    onBlur={this.blur.bind(this)}
                    onChange={this.setValue.bind(this)}
                    value={this.state.form.employee_name}
                    placeholder="Name of Firestorm Employee*"
                    title="Name of Firestorm Employee"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="aplcn-form-section-head">
            <h4>Full Legal Name*</h4>
          </div>
          <div className="aplcn-form-row-main aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                <input
                  type="text"
                  placeholder="First Name*"
                  name="form.fname"
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.fname}
                  title="First name"
                />
              </div>
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                <input
                  type="text"
                  placeholder="Middle Name"
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.sname}
                  name="form.sname"
                  title="Middile Name"
                />
              </div>
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                <input
                  type="text"
                  placeholder="Last Name*"
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.lname}
                  name="form.lname"
                  title="Last name"
                />
              </div>
            </div>
          </div>
          <div className="aplcn-form-section-head">
            <h4>Physical Address*</h4>
          </div>
          <div className="aplcn-form-row-main aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <input
                  id="physicalStreetAddress1"
                  type="text"
                  placeholder="Physical Address Line 1* "
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.physicalStreetAddress1}
                  name="form.physicalStreetAddress1"
                  title="Physical Address Line 1"
                />
              </div>
              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <input
                  id="physicalStreetAddress2"
                  type="text"
                  placeholder="Physical Address Line 2"
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.physicalStreetAddress2}
                  name="form.physicalStreetAddress2"
                  title="Physical Address Line 2"
                />
              </div>
            </div>
          </div>
          <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                <input
                  id="physicalCity"
                  type="text"
                  placeholder="City*"
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.physicalCity}
                  name="form.physicalCity"
                  title="City"
                />
              </div>
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                <input
                  id="physicalState"
                  type="text"
                  placeholder="State*"
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.physicalState}
                  name="form.physicalState"
                  title="State"
                />
              </div>
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                <input
                  id="physicalZip"
                  type="number"
                  placeholder="Zip*"
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.physicalZip}
                  name="form.physicalZip"
                  title="Zip"
                  onKeyDown={this.preventNegativeValueInDocs}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
          </div>

          <div className="aplcn-form-section-head">
            <h4>Current Mailing Address*</h4>
          </div>
          <input
            id="chkSameAddress"
            type="checkbox"
            name="chkSameAddress"
            defaultValue={this.state.chkSameAddress}
            onChange={this.handleAddress.bind(this)}
            style={{
              cursor: "pointer",
              marginRight: "0px",
              display: "inline-block",
              appearance: "auto",
              width: "20px",
              marginBottom: "20px",
            }}
          />
          <span
            className="wpcf7-list-item-label"
            onClick={this.toggleAddressCheckbox.bind(this)} // Added onClick event to the label
            style={{ cursor: "pointer" }}
          >
            <b>&nbsp;&nbsp;Same as Physical Address</b>
          </span>
          <br />
          <div className="aplcn-form-row-main aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <input
                  id="mailingAddress1"
                  type="text"
                  placeholder="Address Line 1* "
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.mailingAddress1}
                  name="form.mailingAddress1"
                  title="Address 1"
                  readOnly={this.state.maddress1}
                  style={{
                    pointerEvents: this.state.maddress1 ? "none" : "auto",
                  }}
                />
              </div>
              <div className="col-sm-12 col-md-6 aplcn-inp-wrap">
                <input
                  id="mailingAddress2"
                  type="text"
                  placeholder="Address Line 2"
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.mailingAddress2}
                  name="form.mailingAddress2"
                  title="Address 2"
                  readOnly={this.state.maddress2}
                  style={{
                    pointerEvents: this.state.maddress2 ? "none" : "auto",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="aplcn-form-row-main aplcn-has-top-space aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                <input
                  id="city"
                  type="text"
                  placeholder="City*"
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.city}
                  name="form.city"
                  title="City"
                  readOnly={this.state.mcity}
                  style={{ pointerEvents: this.state.mcity ? "none" : "auto" }}
                />
              </div>
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                <input
                  id="state"
                  type="text"
                  placeholder="State* "
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.state}
                  name="form.state"
                  title="State"
                  readOnly={this.state.mstate}
                  style={{ pointerEvents: this.state.mstate ? "none" : "auto" }}
                />
              </div>
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                <input
                  id="zip"
                  type="number"
                  placeholder="Zip*"
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.zip}
                  name="form.zip"
                  title="Zip"
                  readOnly={this.state.mzip}
                  style={{ pointerEvents: this.state.mzip ? "none" : "auto" }}
                  onKeyDown={this.preventNegativeValueInDocs}
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
          </div>
          <div className="aplcn-form-section-head">
            <h4>Contact Information*</h4>
          </div>
          <div className="aplcn-form-row-main  aplcn-has-inputs">
            <div className="row aplcn-row">
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                {/* <input
                  type="email"
                  placeholder="Email Address*"
                  required
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.email}
                  name="form.email"
                  title="Email"
                /> */}
                <div className="aplcn-input-demo">{this.state.form.email}</div>
              </div>
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                <NumberFormat
                  placeholder="Cell Phone (Main Contact)*"
                  required
                  data-validation="phonenumber"
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  name="form.main_phone"
                  value={this.state.form.main_phone}
                  format="(###) ###-####"
                  mask=""
                  title="Cell Phone (Main Contact)"
                />
              </div>
              <div className="col-sm-12 col-md-4 aplcn-inp-wrap">
                <NumberFormat
                  placeholder="Secondary Phone"
                  data-validation="phonenumber"
                  onChange={this.setValue.bind(this)}
                  onBlur={this.blur.bind(this)}
                  value={this.state.form.secondary_phone}
                  name="form.secondary_phone"
                  format="(###) ###-####"
                  mask=""
                  title="Secondary Phone"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 aplcn-form-main-actionbar">
              <div className="aplcn-form-actionbar">
                <button
                  onClick={(event) => {
                    event.preventDefault();
                  }}
                  disabled={true}
                  type="button"
                  className="aplcn-prev-button"
                >
                  Previous
                </button>
                <button type="submit" className="aplcn-next-btn">
                  Next
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return state;
}
const connectedApp = connect(mapStateToProps)(PersonalInfo);
export { connectedApp as PersonalInfo };
